// extracted by mini-css-extract-plugin
export default {"menu":"WOYQvc92DDqV8EAIiigi","heading":"pHAhWZJaPa9CnwFeuYpA"};